import { render, staticRenderFns } from "./inviteRule.vue?vue&type=template&id=2d90ab1a&scoped=true&"
import script from "./inviteRule.vue?vue&type=script&lang=js&"
export * from "./inviteRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90ab1a",
  null
  
)

export default component.exports